import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind CSSクラス名を結合するユーティリティ関数
 * 条件付きクラス名の適用と競合の解決を行う
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
